import React, {useState, useEffect} from "react"
import {useDispatch, useStore} from "../Store"
import {useTranslation} from "react-i18next"
import {useOnUpdate} from "../hooks"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"

export default function SenarioTrend({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {locale, perspective, senarioTrendIds, rankingListParam, rankingListTarget},
  } = useStore()
  const options = [
    {
      key: `desc`,
      labelEn: t(`upTrend_EN`),
      labelJa: t(`upTrend_JA`),
    },
    {
      key: `asc`,
      labelEn: t(`downTrend_EN`),
      labelJa: t(`downTrend_JA`),
    },
  ]

  const getValue = () => {
    let value = options.find((h) => h.key === rankingListTarget.trend)
    if (!value) {
      value = options.find((h) => h.key === rankingListParam[perspective].trend)
      if (!value) {
        value = options[0]
      }
    }
    return value
  }

  const setValue = (v) => {
    if (rankingListTarget.trend === v.key)
      return
    dispatch({
      type: `RANKING_LIST_TARGET`,
      trend: v.key
    })
  }

  const [key, setKey] = useState(false)
  const usesenarioTrend = () => {
    setKey(!key)
  }
  useOnUpdate(usesenarioTrend, [locale])

  useEffect(() => {
    setValue(getValue())
  }, [perspective])

  const handleChange = async (v) => {
    if (id !== senarioTrendIds[perspective])
      return
    if (!v)
      setValue(getValue())
    else
      setValue(v)
  }

  return (
    <VirtualSelect
      id={senarioTrendIds[perspective]}
      key={key}
      required={false}
      target={`senarioTrend`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={t(`senarioTrend`)}
      options={options}
      onChange={handleChange}
      value={getValue()}
    />
  )
}
